var App = App || {};

App.Base = (function () {
    'use strict';

    const state = {
        modalUrls: [],
        observerMap: new WeakMap(),
        animationFinishers: new WeakMap()
    };

    // Loads modal URLs and initializes page-level JS behaviors; called on DOMContentLoaded.
    const pageLoad = async () => {
        //try {
        //    state.modalUrls = await App.Modals.fetchModalUrls();
        //    console.log("Fetched modal URLs:", state.modalUrls);
        //} catch (error) {
        //    console.error("Failed to fetch modal URLs:", error);
        //    state.modalUrls = [];
        //}
        observeAndInitializeJs(document);
        App.CustomModals.init();
        handleAnchorClick(document);
        App.Helpers.responsiveTables(document);
        document.addEventListener('hide.bs.tab', completeTabAnimations);
        //App.Bootstrap.activateElement(document, location.hash);
    };


    // Initializes JS for elements with [data-init-js] and observes for new ones dynamically.
    const observeAndInitializeJs = (context = document.body) => {

        // Initialize all current [data-init-js] elements
        const initializations = context.querySelectorAll('[data-init-js]');
        initializations.forEach(initialization => {
            const initializationKey = initialization.dataset.initJs;
            const fn = App.Initialization[initializationKey]?.initialize;
            if (typeof fn !== "function") {
                console.warn("No js initialization handler for:", initializationKey);
                return;
            }
            fn(initialization);
            initialization.removeAttribute("data-init-js");
        });

        // Only attach one observer per context
        if (state.observerMap.has(context)) {
            return;
        }

        // Set up a MutationObserver to watch for new elements needing JS initialization
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach(mutation => {
                for (const node of mutation.addedNodes) {

                    const isElement = node.nodeType === 1;
                    const isDirectInitJs = isElement && node.hasAttribute?.('data-init-js');
                    const hasInitJsDescendant = isElement && node.querySelector?.('[data-init-js]');
                    const shouldInitialize = isDirectInitJs || hasInitJsDescendant;

                    if (shouldInitialize) {
                        const newInitializations = context.querySelectorAll('[data-init-js]');
                        newInitializations.forEach(initialization => {
                            const initializationKey = initialization.dataset.initJs;
                            const fn = App.Initialization[initializationKey]?.initialize;
                            if (typeof fn === "function") {
                                fn(initialization);
                                initialization.removeAttribute("data-init-js");
                                return;
                            }
                            console.warn("No js initialization handler for:", initializationKey);
                        });
                        break;
                    }
                }
            });
        });

        observer.observe(context, { childList: true, subtree: true });
        state.observerMap.set(context, observer);


        // Initialize animations
        onScrollInit(document.querySelectorAll('.os-animation'));

        // Handle staggered animations
        document.querySelectorAll('.staggered-animation')
            .forEach(el => {
                onScrollInit(new Array(el), el.closest('.staggered-animation-container'));
            });
    };

    // Anchor click handling by context to delegate Bootstrap elements, modals, speedbumps
    const handleAnchorClick = (context) => {
        if (!context || context._handleAnchorClickAttached) return;
        context._handleAnchorClickAttached = true;

        const handleCopyClick = (e) => {
            const copyTrigger = e.target.closest('[data-copy]');
            if (!copyTrigger || !context.contains(copyTrigger)) return false;

            const textToCopy = copyTrigger.dataset.copy;
            if (!textToCopy) return false;

            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    var tooltip = new bootstrap.Tooltip(e.target);
                    tooltip.show();

                    setTimeout(() => {
                        tooltip.hide();
                    }, 1000);
                })
                .catch(console.error);

            return true;
        };

        const handlers = [
            (ctx, a) => {
                const href = a.getAttribute("href") || "";
                App.Bootstrap.activateElement(ctx, href)
            },
            (ctx, a) => App.Modals.openModalFromAnchor(state.modalUrls, a),
            (ctx, a) => App.SpeedBump.initialize(a),
        ];

        const handleClick = (e) => {
            if (handleCopyClick(e)) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            const anchor = e.target.closest("a");
            if (!anchor || !context.contains(anchor)) return;

            const handled = handlers.some(fn => fn(context, anchor) === true);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        context.addEventListener("click", handleClick);
    };

    const addOverlay = () => {
        if (!document.body.querySelector('.overlay')) {
            const overlay = document.createElement('div');
            overlay.className = 'overlay fade';
            document.body.prepend(overlay);

            // Add show on next frame so CSS transitions can fire consistently
            requestAnimationFrame(() => {
                overlay.classList.add('show');
            });
        }
    }

    const removeOverlay = () => {
        document.body.querySelectorAll('.overlay').forEach((overlay) => overlay.remove());
    }

    const completeTabAnimations = (event) => {
        const targetSelector = event.target.getAttribute('data-bs-target');
        const tabPanel = targetSelector && document.querySelector(targetSelector);

        tabPanel?.querySelectorAll('.animate__animated').forEach(element => {
            state.animationFinishers.get(element)?.();
        });
    };

    const onScrollInit = (items, trigger) => {
        items.forEach(element => {
            const animationClass = element.dataset.osAnimation;
            const animationDelay = element.dataset.osAnimationDelay;

            // Apply animation delay
            element.style.animationDelay = animationDelay;

            const animationTrigger = trigger || element;

            // Using IntersectionObserver instead of Waypoint
            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    const finishAnimation = () => {
                        element.classList.add('animation-complete');
                        element.classList.remove('animate__animated', animationClass);
                        element.removeEventListener('animationend', finishAnimation);
                        observer.disconnect();
                        state.animationFinishers.delete(element);
                    };

                    state.animationFinishers.set(element, finishAnimation);
                    element.addEventListener('animationend', finishAnimation, { once: true });

                    element.classList.add('animate__animated', animationClass);
                }
            }, {
                threshold: 0.10,
                rootMargin: '0px'
            });

            observer.observe(animationTrigger);
        });
    };

    return {
        pageLoad,
        handleAnchorClick,
        addOverlay,
        removeOverlay
    };

})();

document.addEventListener("DOMContentLoaded", function () {
    App.Base.pageLoad();
});